export const DEFINITION_GETTER_NAME = 'definition'
